import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import Collection from './generic/collection'
import { getCfg } from "./utils/getCfg"
import { makeRequest } from './utils/makeRequest'
import Loader from '../components/calculator-ma/components/loader'

const App = lazy(() => import(/* webpackChunkName: "CalculatorMa" */"../components/calculator-ma/App"))

export const instance = '[data-js-calculator-ma]'

export class CalculatorMa {

  static els = {
    instance,
  }

  static layouts = {
    modalError: `<div class="modal modal--error" id="modal-error">
            <div class="login-box">
                <div class="card card-outline popup-card popup-card_error">
                    <div class="card-body">
                        <p class="custom-login-box-msg  mb-3 popup-card__title">Произошла ошибка</p>
                        <i class="far fa-times-circle"></i>
                    </div>
                </div>
            </div>
        </div>`
  }

  static defaultCfg = { baseClass: "Calculator-ma", localeKey: CalculatorMa.els.instance }

  constructor (instance) {
    this.instance = instance
    this.init()
  }

  render(isLoading = true) {
    ReactDOM.render(
      isLoading ? <Loader/> :
        <Suspense fallback={<Loader/>}>
          <App {...this.cfg} />
        </Suspense>, this.instance
    )
  }

  async getData() {
    return makeRequest({ url: this.cfg.url })
      .then(({ success, data, errors }) => {
        if (success) {
          return data
        } else {
          return Promise.reject(errors)
        }
      })
  }

  init() {
    this.render()
    this.cfg = getCfg(this.instance, CalculatorMa.els.instance, CalculatorMa.defaultCfg);
    this.getData()
      .then((data) => {
        this.cfg.data = data
      })
      .catch((e) => {
        $.fancybox.open({
          src: CalculatorMa.layouts.modalError,
          type: 'html'
        })
        console.debug('Failed to get data: ', e)
      })
      .finally(() => {
        this.render(false)
      })
  }
}

export class CalculatorMaCollection extends Collection {
  constructor() {
    super(instance, CalculatorMa)
    this.init()
  }
  init(context = document) {
    context.querySelectorAll(instance).forEach((el) => {
      this.collection = new CalculatorMa(el)
    })
  }
}